import { render, staticRenderFns } from "./StoriesCard.vue?vue&type=template&id=7ec7b728"
import script from "./StoriesCard.vue?vue&type=script&lang=js"
export * from "./StoriesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports